import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apiintegration',
  templateUrl: './apiintegration.component.html',
  styleUrls: ['./apiintegration.component.scss']
})
export class ApiintegrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
